import type { PublicationListOut } from '@/api/generated/schemas';

export type ProductKind = 'ebook' | 'audio';

/**
 * Which format a ledger product id stands for. Settlement rows only carry the
 * product id, so the format is read back off the publication it belongs to.
 */
export const productKind = (
  publication: PublicationListOut | undefined,
  productId: number
): ProductKind | null => {
  if (publication?.ebook?.id === productId) return 'ebook';
  if (publication?.audio?.id === productId) return 'audio';
  return null;
};
